export default __webpack_public_path__ + "static/media/ZZC_7833.b207c02a.jpg";